import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import compact from 'lodash/compact'

export const useFileUploaderWithForm = (maxFileCount = 5) => {
  const { setError, setValue, watch, clearErrors } = useFormContext()
  const files: File[] = watch('files')

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      clearErrors('files')

      if (files.length === 0) {
        if (acceptedFiles.length > maxFileCount) {
          return setError('files', {
            message: `파일은 최대 ${maxFileCount}개까지 업로드할 수 있습니다`,
          })
        }
        return setValue('files', acceptedFiles)
      }

      const newFiles = compact(
        acceptedFiles.map((file: File) => {
          const exists = files.map((file) => file.name).includes(file.name)
          if (!exists) return file

          return setError('warning', {
            message: '중복된 파일을 제외하고 첨부되었습니다.',
          })
        })
      )

      if (newFiles && newFiles.length > 0) {
        const newValue = files.concat(newFiles as File[])
        if (newValue.length > maxFileCount) {
          return setError('files', {
            message: `파일은 최대 ${maxFileCount}개까지 업로드할 수 있습니다`,
          })
        }
        setValue('files', newValue)
      }
    },
    [clearErrors, files, maxFileCount, setError, setValue]
  )

  const onDropRejected = useCallback(() => {
    setError('files', {
      message: '20MB 이하의 파일만 업로드할 수 있습니다.',
    })
  }, [setError])

  const onRemoveFile = useCallback(
    (fileName: string) => {
      const filtered = files.filter((file) => file.name !== fileName)
      setValue('files', filtered)
    },
    [files, setValue]
  )

  return {
    onRemoveFile,
    onDrop,
    onDropRejected,
  }
}
